"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { closeIcon } from "@public/icons";
import Image from "next/image";

const Modal = ({ isOpen, handleModalToggle, children, sizeClass, title, closeOptins }) => {
  const [modalRoot, setModalRoot] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    setModalRoot(document.getElementById("modal-root"));
  }, []);

  useEffect(() => {
    if (isOpen) {
      setScrollPosition(window.scrollY);
      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.left = "0";
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollPosition);
    }

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.width = "";
    };
  }, [isOpen]);

  if (!modalRoot) return null;

  return createPortal(
    <div
      className={`fixed inset-0 z-2000 flex items-center justify-center transition-opacity duration-300 ${
        isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
      }`}
      onClick={closeOptins ? null : handleModalToggle}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

      <div
        onClick={(e) => e.stopPropagation()}
        className={`${sizeClass} relative mx-auto flex max-h-[90vh] flex-col overflow-y-auto rounded-xl bg-white bg-clip-border text-gray-700 shadow-md`}
      >
        <button
          aria-label="Close"
          onClick={closeOptins ? null : handleModalToggle}
          className="absolute top-4 left-4"
        >
          <Image className="size-8" src={closeIcon} alt="close" />
        </button>
        {title && <h2 className="pt-7 text-center text-2xl font-bold">{title}</h2>}
        <div>{children}</div>
      </div>
    </div>,
    modalRoot,
  );
};

export default Modal;
